'use strict';

require('./string');
require('./number');
require('./array');
require('./enumerable');
require('./object');
require('./date');
require('./range');
require('./function');
require('./regexp');

module.exports = require('sugar-core');


//////////////////
// WEBPACK FOOTER
// ./~/sugar/index.js
// module id = 646
// module chunks = 0